export class MyPositionController {

    public permalinkKey = "myposition";
    public leagueId: number;
    public pagination: any;
    public contestant: any;
    public contestantId: number = null;
    public getData: any;


    public static $inject = ["$scope", "$location"];
    constructor(
        private $scope: angular.IScope,
        private $location: angular.ILocationService
    ) {
    }

    public $onInit() {
        this.$scope.$on("$locationChangeSuccess", this.setContestant.bind(this));
        this.setContestant();
    }

    public setPageToContestant() {
        let contestantId;

        if (this.contestantId) {
            contestantId = this.contestantId;
        } else if (this.contestant) {
            contestantId = parseInt(this.contestant.getContestant().getId(), 10);
        } else {
            return;
        }

        this.contestantId = contestantId;
        this.pagination.setLoading(true);

        this.getData({
            leagueId: this.leagueId,
            contestantId: contestantId,
            limit: this.pagination.limit
        })
        .then((data: any) => {
            this.pagination.setOffset(data.offset);
            this.pagination.setTotal(data.total);
            this.pagination.setData(data.data);
        })
        .finally(() => {
            this.pagination.setLoading(false);
        });

        if (this.pagination.permalink && this.pagination.permalink[this.permalinkKey]) {
            this.pagination.cleanUpPermalinks(this.permalinkKey);
            this.$location.search(this.pagination.permalink[this.permalinkKey], contestantId);
        }
    }

    private setContestantId() {
        if (this.pagination.permalink &&
            this.pagination.permalink[this.permalinkKey] &&
            parseInt(this.$location.search()[this.pagination.permalink[this.permalinkKey]], 10)
        ) {
            this.contestantId = parseInt(this.$location.search()[this.pagination.permalink[this.permalinkKey]], 10);
        } else {
            this.contestantId = null;
        }
    }

    private setContestant() {
        let contestantId = this.contestantId;
        this.setContestantId();

        if (contestantId !== this.contestantId) {
            this.setPageToContestant();
        }
    }
}